import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConfirmContractModal } from '../../../common/modals';
import { connectModal } from '../../../features/modal/hoc';
import { selectData } from '../../../features/modal/ducks';
import { confirmPostFinancingActions, resendSmsCodeLoanRequest, selectConfirmError } from '../ducks';
import { apiCallIds } from '../api';

const mapStateToProps = state => ({
  loanId: selectData(state, apiCallIds.CONFIRM_POST_FINANCING),
  confirmError: selectConfirmError(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      confirmPostFinancing: confirmPostFinancingActions.request,
      resendSmsCodeLoan: resendSmsCodeLoanRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(apiCallIds.CONFIRM_POST_FINANCING)
export default class ConfirmPostFinancing extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    loanId: PropTypes.string,
    confirmError: PropTypes.string,
  };

  handleSubmit = token => {
    const { actions, loanId } = this.props;
    actions.confirmPostFinancing({ loanId, token });
  };

  handleResendSmsCode = callbacks => {
    const { actions, loanId } = this.props;
    actions.resendSmsCodeLoan({ loanId, ...(callbacks || {}) });
  };

  render() {
    const { isVisible, isLoading, modalActions, confirmError, loanId } = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <ConfirmContractModal
        hideModal={modalActions.hide}
        isLoading={isLoading}
        onSubmit={this.handleSubmit}
        onResendSmsCode={this.handleResendSmsCode}
        resendCooldownKey={`loan:${loanId}:postFinancing`}
        confirmBy="postFinancing"
        errorMessage={confirmError}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/components/ConfirmPostFinancing.js